import { APIEventEmitter } from '~/src/services/event';
import { EventNameMap } from '~/src/services/event/constants';
import { useEnvironmentStore } from '~/src/store';
import { showFailToast } from 'vant';
import { GLOBAL_CONFIG } from '~/configs/environment/environment';
import { wxBridge } from '~/src/services/wxBridge';
import { miniProgramPageNames } from '~/src/services/wxBridge/constants';

// 应用初始化行为，通过hook监听，在app初始化时执行
export default defineNuxtPlugin(nuxtApp => {
  // 应用创建后钩子.
  nuxtApp.hook('app:created', error => {
    console.log('app:created');

    // api 相关事件监听，接口错误弹窗提示
    APIEventEmitter.on(EventNameMap.API_SERVER_ERROR, error => {
      if (!process.client) {
        return;
      }

      const envStore = useEnvironmentStore();

      let errorMessage = '';

      if (error?._data?.msg) {
        errorMessage = error._data.msg;
      } else {
        if (error.status == 0) {
          errorMessage = '网络出现异常啦 ~  检查网络后再试下吧！';
        } else if (error.status == 302) {
          errorMessage = '您的登录状态已失效，请重新登录';
        } else {
          errorMessage = '接口报错,状态码：' + error.status;
        }
      }

      if (envStore.isMobile) {
        showFailToast(errorMessage || 'Server Error.');
      } else {
        ElMessage.error(errorMessage || 'Server Error.');
      }
    });

    APIEventEmitter.on(EventNameMap.API_UN_LOGIN, error => {
      if (!process.client) {
        return;
      }

      // TODO: 未登录跳login
      console.log('location to login.');
      const envStore = useEnvironmentStore();

      if (envStore.platform === 'miniProgram') {
        wxBridge.routerTo({
          type: 'replace',
          url: miniProgramPageNames.login,
        });
      }
      // window.location.href = `${GLOBAL_CONFIG.envConfig.homeUrl}/index?reback=${encodeURIComponent(window.location.href)}`;
    });
  });
});
